module.exports = __webpack_public_path__ + "static/media/24UHCHR12.e1242a9f.jpg";